import { Pesel } from '@dreryk/personal-external-identifier-common-api';

import { FormContextValues } from '@dreryk/react-common';

import { PatientSelectIdentifierType } from '../PatientIdentifierTypeField/PatientIdentifierTypeField';
import { PersonalIdentifierType } from '../../common.types';

import { BirthDateField } from './BirthDateField';
import { BirthDateTextView } from './BirthDateTextView';

type BirthDateFormBeanPart = {
   personalIdentifierType: PatientSelectIdentifierType;
   pesel?: Pesel | null;
};

type BirthDateProps = Pick<FormContextValues<BirthDateFormBeanPart>, 'register' | 'watch'>;

export const BirthDate = (props: BirthDateProps): JSX.Element => {
   const { personalIdentifierType, pesel } = props.watch(['personalIdentifierType', 'pesel']);

   if (personalIdentifierType.id === PersonalIdentifierType.PESEL) {
      return <BirthDateTextView birthDate={pesel?.getBirthDate() ?? null} />;
   }

   return <BirthDateField register={props.register} personalIdentifierType={personalIdentifierType} />;
};
